import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { intelColors } from './intelTheme'

export default function IntelLayout({ title, children }) {
  const location = useLocation()

  // First-paint fix: recharts ResponsiveContainer can measure width=0 on below-fold mount and not
  // re-measure until an interaction. Nudge a few resize events after layout settles + async data
  // typically lands, so charts always paint on first load.
  useEffect(() => {
    const timers = [120, 450, 1100].map((ms) => setTimeout(() => window.dispatchEvent(new Event('resize')), ms))
    return () => timers.forEach(clearTimeout)
  }, [location.pathname])

  return (
    <Box sx={{ background: intelColors.pageBg, minHeight: '100vh', p: '20px 24px' }}>
      <Typography sx={{ fontSize: 18, fontWeight: 700, color: intelColors.text, mb: 2.5 }}>
        {title}
      </Typography>
      {children}
    </Box>
  )
}
